import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { OptionService } from '../option.service';
import { SystemData } from '../systemData.model';
import { ThemePalette } from '@angular/material/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-system-data',
  templateUrl: './system-data.component.html',
  styleUrls: ['./system-data.component.css']
})
export class SystemDataComponent implements OnInit {

  systemData: SystemData = {} as SystemData;
  spinnerOverlay = false
  color: ThemePalette = 'primary';
  EnableHosonSira = false;
  EnableMahkomiah = false;
  EnableMakramah = false;
  EnableMakramahJeash = false;
  EnableUniformAcceptance = false;
  EnableUnivercityFees = false;

  constructor(private service: OptionService, private snackBar: MatSnackBar,
    private translateService: TranslateService) { }

  ngOnInit(): void {
    this.getSystemSettings();
    this.get()
  }

  getSystemSettings() {
    this.service.getSystemSettings("Enable_HosonSira").subscribe(data => {
      this.EnableHosonSira = JSON.parse(data["value"]);
    },
      error => {
        console.log(error);
      });

    this.service.getSystemSettings("Enable_Mahkomiah").subscribe(data => {
      this.EnableMahkomiah = JSON.parse(data["value"]);
    },
      error => {
        console.log(error);
      });

    this.service.getSystemSettings("Enable_Makramah").subscribe(data => {
      this.EnableMakramah = JSON.parse(data["value"]);
    },
      error => {
        console.log(error);
      });

    this.service.getSystemSettings("Enable_MakramahJeash").subscribe(data => {
      this.EnableMakramahJeash = JSON.parse(data["value"]);
    },
      error => {
        console.log(error);
      });

    this.service.getSystemSettings("Enable_UniformAcceptance").subscribe(data => {
      this.EnableUniformAcceptance = JSON.parse(data["value"]);
    },
      error => {
        console.log(error);
      });

    this.service.getSystemSettings("Enable_UnivercityFees").subscribe(data => {
      this.EnableUnivercityFees = JSON.parse(data["value"]);
    },
      error => {
        console.log(error);
      });
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getDefinitions().subscribe(data => {

      if (data != null) {
        this.systemData = data
      }
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  put() {
    this.spinnerOverlay = true;
    this.service.updateDefinitions(this.systemData).subscribe(data => {
      this.openSnackBar(this.translateService.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
    })
  }

  submit() {
    this.put();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  EnableServices(event: MatSlideToggleChange, type: number) {

    this.spinnerOverlay = true;
    var obj = {}
    switch (type) {
      case 1:
        this.EnableHosonSira = event.checked;
        obj = {
          "key": "Enable_HosonSira",
          "value": this.EnableHosonSira ? true : false
        }
        break;
      case 2:
        this.EnableMahkomiah = event.checked;
        obj = {
          "key": "Enable_Mahkomiah",
          "value": this.EnableMahkomiah ? true : false
        }
        break;
      case 3:
        this.EnableMakramah = event.checked;
        obj = {
          "key": "Enable_Makramah",
          "value": this.EnableMakramah ? true : false
        }
        break;
      case 4:
        this.EnableMakramahJeash = event.checked;
        obj = {
          "key": "Enable_MakramahJeash",
          "value": this.EnableMakramahJeash ? true : false
        }
        break;
      case 5:
        this.EnableUniformAcceptance = event.checked;
        obj = {
          "key": "Enable_UniformAcceptance",
          "value": this.EnableUniformAcceptance ? true : false
        }
        break;
      default:
        this.EnableUnivercityFees = event.checked;
        obj = {
          "key": "Enable_UnivercityFees",
          "value": this.EnableUnivercityFees ? true : false
        }
        break;
    }

    this.service.updateSystemSettings(obj).subscribe(data => {
      this.openSnackBar(this.translateService.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })

  }

}
